import useWebChatAPIContext from '/druid/internal/useWebChatAPIContext';

export default function useGrammars(): [any] {
  return [useWebChatAPIContext().grammars];
}
